var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from "mobx";
export class SportModel {
    constructor(sport, type = "sports") {
        this.id = sport.id;
        this.order = sport.order;
        this.name = sport.name;
        this.numberOfEvents = sport.numberOfEvents;
        this.type = type;
    }
    update(newItem) {
        newItem.id && (this.id = newItem.id);
        newItem.order && (this.order = newItem.order);
        newItem.name && (this.name = newItem.name);
        newItem.numberOfEvents && (this.numberOfEvents = newItem.numberOfEvents);
        newItem.type && (this.type = newItem.type);
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], SportModel.prototype, "numberOfEvents", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SportModel.prototype, "update", null);
//# sourceMappingURL=SportModel.js.map